// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { DismissIcon, Typography } from '@iheartjane/reefer';
import type { PropsWithChildren, ReactNode } from 'react';

const ENTICING_GRADIENT = 'linear-gradient(90deg, #E02D52 0%, #C531CA 100%)';

const Bubble = ({ children }: PropsWithChildren) => {
  return (
    <Typography
      as="div"
      color="grays-white"
      // eslint-disable-next-line react/forbid-component-props -- legacy emotion
      css={{
        backgroundImage: ENTICING_GRADIENT,
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        '&::before': {
          content: '""',
          position: 'absolute' as const,
          width: 0,
          height: 0,
          top: -28,
          left: '48%',
          borderLeft: '9px solid transparent',
          borderRight: '9px solid transparent',
          borderTop: '20px solid transparent',
          borderBottom: '8px solid #d23093',
        },
      }}
      px={16}
      py={12}
      position="relative"
      textAlign="center"
      mt={16}
      whiteSpace="normal"
    >
      {children}
    </Typography>
  );
};

const CloseButton = styled.button(({ theme }) => ({
  border: `1px solid ${theme.colors.grays.ultralight}`,
  position: 'absolute' as const,
  width: 30,
  height: 30,
  borderRadius: 15,
  right: -8,
  top: -15,
  background: theme.colors.grays.white,
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)',
}));

interface Props {
  children: ReactNode;
  onClose?: () => void;
}

export const EnticementBubble = ({ children, onClose }: Props) => {
  const theme = useTheme();
  return (
    <Bubble>
      {onClose && (
        <CloseButton onClick={onClose} theme={theme}>
          <DismissIcon size="sm" color="grays-mid" />
        </CloseButton>
      )}
      {children}
    </Bubble>
  );
};
